import { render, staticRenderFns } from "./EventosCalendarioLetivoPage.vue?vue&type=template&id=be104f62"
import script from "./EventosCalendarioLetivoPage.vue?vue&type=script&lang=js"
export * from "./EventosCalendarioLetivoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports